import { render, staticRenderFns } from "./CustomersContent.vue?vue&type=template&id=77b2ceb6&scoped=true"
import script from "./CustomersContent.vue?vue&type=script&lang=js"
export * from "./CustomersContent.vue?vue&type=script&lang=js"
import style0 from "./CustomersContent.vue?vue&type=style&index=0&id=77b2ceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b2ceb6",
  null
  
)

export default component.exports